const state = {
  presetMessages: [],
};
export default state;
